import { render, staticRenderFns } from "./TheCustomizer.vue?vue&type=template&id=373b80fd"
import script from "./TheCustomizer.vue?vue&type=script&lang=js"
export * from "./TheCustomizer.vue?vue&type=script&lang=js"
import style0 from "./TheCustomizer.vue?vue&type=style&index=0&id=373b80fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports